module.exports = __webpack_public_path__ + "media/images/company/cp15-fa12405de42b5d7caae1800d8a108702.png";